import React, { useState } from 'react'

export default ({ id, label, type, value, editMode, validations, onChange, onBlur, ...props }) => {
    const [validationError, setValidationError] = useState(null)

    const validateOnChange = (e) => {
        setValidationError(null)
        if (validations) {
            setValidationError(validations.map(validation => validation(e.target.value)).filter(p => p)[0])
        }
        onChange && onChange(e.target.value)
    }

    const validateOnBlur = (e) => {
        setValidationError(null)
        if (validations) {
            setValidationError(validations.map(validation => validation(e.target.value)).filter(p => p)[0])
        }
        onBlur && onBlur(e.target.value)
    }

    return (
        <div>
            <label htmlFor={id}>{label}</label>
            <div className="form-group">
                {editMode
                    ? <input {...props} name={id} type={type || "text"} className={`form-control ${validationError ? 'input-validation-error' : ''}`} onChange={validateOnChange} onBlur={validateOnBlur} defaultValue={value} placeholder={label} />
                    : <span>{value || '-'}</span>
                }
                {validationError && editMode && <span className='validation-message field-validation-error'>{validationError}</span>}
            </div>
        </div>
    )
}


